var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMatchPercent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24.762 0C25.446 0 26 .554 26 1.238v23.524c0 .684-.554 1.238-1.238 1.238H1.238A1.238 1.238 0 0 1 0 24.762V1.238C0 .554.554 0 1.238 0zM17.5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-.405-8.92c-.256-.153-.616-.083-.849.18l-9.05 10.22-.07.092c-.187.283-.166.642.063.845l1.635 1.444.081.06c.256.152.616.082.849-.181l9.05-10.22.07-.092c.187-.283.166-.642-.063-.845l-1.635-1.444zM8.5 6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMatchPercent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/match-percent.e6cd9c226a71fb8fc858a0c075151c14.svg";